/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Type_PersonInputs */

const en_clients_type_person = /** @type {(inputs: Clients_Type_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

const pt_br2_clients_type_person = /** @type {(inputs: Clients_Type_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pessoa Física`)
};

/**
* | output |
* | --- |
* | "Person" |
*
* @param {Clients_Type_PersonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_type_person = /** @type {((inputs?: Clients_Type_PersonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Type_PersonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_type_person(inputs)
	return pt_br2_clients_type_person(inputs)
});